/**
 * Returns true if it have to show the log message
 */
var itMustLog = function itMustLog() {
  if (typeof __DEV__ !== undefined) return true;
  if (window) if (window.DEBUG) return true;
  if (process) if (process.env) {
    var enviroment = process.env.NODE_ENV;

    if (typeof enviroment === "string") {
      if (enviroment === "development" || enviroment === "dev") return true;
    }
  }
  return false;
};

var info = function info() {
  var _console;

  if (!itMustLog()) return;

  (_console = console).info.apply(_console, arguments);
};

var log = function log() {
  var _console2;

  if (!itMustLog()) return;

  (_console2 = console).log.apply(_console2, arguments);
};

var error = function error() {
  var _console3;

  if (!itMustLog()) return;

  (_console3 = console).error.apply(_console3, arguments);
};

var debug = function debug() {
  var _console4;

  if (!itMustLog()) return;

  (_console4 = console).debug.apply(_console4, arguments);
};

module.exports = {
  info: info,
  log: log,
  error: error,
  debug: debug
};